import { fetchStudies } from 'api/study';
import { map } from 'es-toolkit/compat';
import { useCurrentLabId } from 'utils/useCurrentLab';
import { useQueryWithErrorAndRetrySnackbar } from 'utils/useQueryWithErrorAndRetrySnackbar';

interface StudyOption {
  value: string;
  text: string;
}

/**
 * Lightweight hook that fetches only the study options for the current lab.
 * Unlike useMainFilters, this does NOT trigger the procedure fields pipeline
 * (stain types, clinical data, etc.), avoiding unnecessary API calls on
 * routes that only need the study list (e.g. the report shell).
 */
const useStudyReportOptions = () => {
  const { labId } = useCurrentLabId();

  const studiesQuery = useQueryWithErrorAndRetrySnackbar(['studies', labId], () => fetchStudies(labId), {
    enabled: Boolean(labId),
    queriedEntityName: 'studies',
  });

  const studyOptions: StudyOption[] | null = studiesQuery.data
    ? map(studiesQuery.data, (study) => ({ value: study.id, text: study.name }))
    : null;

  return {
    studyOptions,
    studiesLoading: studiesQuery.isLoading,
  };
};

export default useStudyReportOptions;
